import React, { useState } from 'react';
import {
    IonButton,
    IonCard,
    IonCardContent,
    IonCardHeader,
    IonCardTitle,
    IonInput,
    IonItem,
    IonLabel,
    IonList,
    IonText,
    useIonToast
} from '@ionic/react';
import { AuthenticationState, useAuth } from '../contexts/AuthContext';

export const LoginForm: React.FC = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState<string | null>(null);
    const { login, authState } = useAuth();
    const [present] = useIonToast();

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setError(null);

        try {
            await login(email, password);
            present({
                message: 'Successfully logged in',
                duration: 3000,
                position: 'bottom',
                color: 'success'
            });
        } catch (err) {
            const message = err instanceof Error ? err.message : 'Failed to login';
            setError(message);
            present({
                message,
                duration: 3000,
                position: 'bottom',
                color: 'danger'
            });
        }
    };

    return (
        <form onSubmit={handleSubmit}>
            <IonCard>
                <IonCardHeader>
                    <IonCardTitle>Login</IonCardTitle>
                </IonCardHeader>
                <IonCardContent>
                    <IonList>
                        <IonItem>
                            <IonLabel position="floating">Email</IonLabel>
                            <IonInput
                                type="email"
                                value={email}
                                onIonChange={e => setEmail(e.detail.value || '')}
                                onInput={e => setEmail((e.target as HTMLInputElement).value)}
                                required
                            />
                        </IonItem>
                        <IonItem>
                            <IonLabel position="floating">Password</IonLabel>
                            <IonInput
                                type="password"
                                value={password}
                                onIonChange={e => setPassword(e.detail.value || '')}
                                onInput={e => setPassword((e.target as HTMLInputElement).value)}
                                required
                            />
                        </IonItem>
                    </IonList>

                    {error && (
                        <IonText color="danger">
                            <p className="ion-padding-start">{error}</p>
                        </IonText>
                    )}

                    <div className="ion-padding-top">
                        <IonButton
                            expand="block"
                            type="submit"
                            disabled={authState == AuthenticationState.INITIALIZING}
                        >
                            {authState == AuthenticationState.INITIALIZING ? 'Logging in...' : 'Login'}
                        </IonButton>
                    </div>
                </IonCardContent>
            </IonCard>
        </form>
    );
}; 